import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogData } from "src/app/header/header.component";

@Component({
	selector: 'dialog-overview-example-dialog',
	templateUrl: 'cancel-confirmation.component.html',
  })
  export class CancelConfirmationComponent {

    constructor(
      public dialogRef: MatDialogRef<CancelConfirmationComponent>,
      @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

    onNoClick(): void {
      this.dialogRef.close();
    }

  }